<template>
  <div class="selector">
    <div
      v-for="(system, index) in symptoms"
      :class="['panel', { collapse: !expanded[index] }]"
    >
      <div class="panel-heading is-clearfix pointer" @click="expand(index)">
        <i v-if="!expanded[index]" class="fa fa-angle-right pull-right"></i>
        <i
          v-if="expanded[index] === true"
          class="fa fa-angle-down pull-right"
        ></i>
        {{ system.name }}
      </div>
      <div class="panel-block" v-for="symptom in system.symptoms">
        <label :for="symptom.id">
          <input
            type="checkbox"
            :id="symptom.id"
            :value="symptom.id"
            v-model="reasons"
          />

          {{ symptom.name }}

          <input
            type="tel"
            class="symptom-duration"
            :ref="`duration-${symptom.id}`"
            value=""
            placeholder="duration"
            name="symptom-duration"
            @change="updateReasons(symptom.id)"
          />

          <input
            class="symptom-notes"
            :ref="`notes-${symptom.id}`"
            value=""
            placeholder="notes"
            name="symptom-notes"
            @change="updateReasons(symptom.id)"
          />
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";

export default {
  name: "reason-selector",

  props: ["rfv", "updated"],

  data() {
    return {
      expanded: [],
      reasons: []
    };
  },

  computed: {
    symptoms() {
      return this.$store.getters["symptom/list"];
    }
  },

  watch: {
    reasons(newValue, oldValue) {
      const removed = _.difference(oldValue, newValue);
      if (removed.length) {
        this.$refs[`duration-${removed[0]}`][0].value = "";
      }
      this.emitUpdate(this.reasons);
    }
  },

  methods: {
    expand(index) {
      const newExpanded = _.cloneDeep(this.expanded);
      if (newExpanded[index]) {
        newExpanded[index] = false;
      } else {
        newExpanded[index] = true;
      }
      this.expanded = newExpanded;
    },
    updateReasons(id) {
      if (this.$refs[`duration-${id}`][0].value) {
        this.emitUpdate(this.reasons.push(id));
      }
    },
    emitUpdate(reasons) {
      const reasonForVisit = [];
      _.forEach(_.uniq(reasons), reason => {
        reasonForVisit.push({
          name: this.$store.getters["symptom/name"](reason),
          duration: this.$refs[`duration-${reason}`][0].value,
          notes: this.$refs[`notes-${reason}`][0].value
        });
      });

      this.$emit("updated", reasonForVisit);
    }
  },

  mounted() {
    _.forEach(this.rfv, r => {
      const id = this.$store.getters["symptom/name2id"](r.name);
      this.reasons.push(id);
      this.$refs[`duration-${id}`][0].value = r.duration;
      this.$refs[`notes-${id}`][0].value = r.notes;
    });
  }
};
</script>

<style lang="scss" scoped>
.selector {
  max-height: 300px;
  overflow: scroll;
}
.symptom-duration {
  width: 60px;
}
.symptom-notes {
  width: 100px;
}
.collapse {
  .panel-block {
    display: none;
  }
}
</style>
